import React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { routes } from "@common/constants/urls";
import analyticsService, {
  ANALYTICS_TYPES,
} from "@common/services/analyticsService";
import "./status-fermentation-interrupted.scss";

// Rendered when kegFermentationInterrupted(device) matches: the keg was left
// idle with the cleaning gate while its session is still ACTIVE — the state a
// failed fermentation edit strands it in. Resume is primary; cleaning stays
// one tap away because a deliberately finished batch reaches the same device
// state and must not lose its path.
// Named export = unconnected form for tests; default export = connected.
// A class (not a stateless function) because tracking the impression needs
// componentDidMount, and hooks are banned in this codebase.
export class StatusFermentationInterrupted extends React.Component {
  componentDidMount() {
    analyticsService.track(ANALYTICS_TYPES.FERMENTATION_INTERRUPTED_SHOWN, {
      Device: this.props.device.uuid,
    });
  }

  render() {
    const { device, showEditFermentationModal, dispatch } = this.props;

    return (
      <div className="device__status--interrupted">
        <div className="device__interrupted-text">
          Fermentation interrupted — the keg is not fermenting right now.
        </div>
        <button
          className="device__interrupted-resume"
          onClick={() => {
            analyticsService.track(
              ANALYTICS_TYPES.FERMENTATION_INTERRUPTED_RESUME,
              { Device: device.uuid },
            );
            showEditFermentationModal(device);
          }}
        >
          Resume fermentation
        </button>
        <button
          className="device__interrupted-clean"
          onClick={() => dispatch(push(routes.monitoring + device.session_id))}
        >
          Finished on purpose? Clean the keg
        </button>
      </div>
    );
  }
}

export default connect(undefined, undefined)(StatusFermentationInterrupted);
